import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { REQUEST_REMOTE_CONNECTION } from "./messageTypes";

export const sendRemoteConnectionRequest = (id: { id: StringID }) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOTE_CONNECTION, id);
};
